declare global {
  interface Window { MX97_RUNTIME_CONFIG?: { apiOrigin?: string } }
}

const configured = window.MX97_RUNTIME_CONFIG?.apiOrigin?.trim();
const endpoint = new URL(configured || location.origin);
if (!['http:', 'https:'].includes(endpoint.protocol) || endpoint.username || endpoint.password || endpoint.pathname !== '/' || endpoint.search || endpoint.hash || (location.protocol === 'https:' && endpoint.protocol !== 'https:')) {
  throw new Error('Invalid API origin in runtime-config.js');
}
export const apiOrigin = endpoint.origin;

export function apiUrl(path: string): string {
  const url = new URL(path, apiOrigin + '/');
  if (url.origin !== apiOrigin) throw new Error('Unexpected API origin');
  return url.href;
}

export function socketUrl(path: string): string {
  const url = new URL(apiUrl(path));
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  return url.href;
}

export function publicAssetUrl(path: string): string {
  return /^\/(?:admin\/upload|upload|notice|support)\//.test(path) ? apiUrl(path) : path;
}

export function noticeHtml(value: string): string {
  const template = document.createElement('template');
  template.innerHTML = value;
  template.content.querySelectorAll('[src],[href]').forEach(element => {
    for (const name of ['src', 'href']) {
      const path = element.getAttribute(name);
      if (path) element.setAttribute(name, publicAssetUrl(path));
    }
  });
  return template.innerHTML;
}
